angular.module('CarsSaraBo').config(['$routeProvider', function($routeProvider) {
	$routeProvider.when("/eva-template", {
		templateUrl: 'assets/eva-template/index.html',
		controller: 'TemplateController'
	});
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/template_route.js
// module id = 822
// module chunks = 3